/* Go Honey 2026-10-20: pre-order label inside quick shop (home grid, search, "You may also like").
   A product with custom.ships_out shows that text on the add button for sizes that can be bought but are at 0 or
   below, and hides the theme's "In stock" note for them. snippets/quick-shop.liquid renders the opening state and the
   data attributes; this script repeats it when the size changes. Quick-shop HTML is inserted with innerHTML, so an
   inline script there would never run. The product page has its own copy in snippets/pdp-blocks.liquid. */
(function () {
  function apply(root, variantId) {
    var box = root.querySelector('[data-gh-ships-label]');
    if (!box) return;
    var label = box.getAttribute('data-gh-ships-label');
    var pre = (box.getAttribute('data-gh-preorder') || '').indexOf('|' + variantId + '|') > -1;
    var text = root.querySelector('button[name="add"] staged-action-text');
    var note = root.querySelector('[id^="inventory-notice-"]');
    if (text) {
      if (pre) text.textContent = label;
      else if (text.textContent.trim() === label) text.textContent = box.getAttribute('data-gh-add-text') || 'Add to cart';
    }
    if (note) note.style.display = pre ? 'none' : '';
  }
  // Capture phase: the theme dispatches on:variant:change without bubbling, after it has redrawn the button and note.
  document.addEventListener('on:variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    var root = variant && e.target && e.target.closest ? e.target.closest('quick-shop') : null;
    if (!root) return;
    apply(root, variant.id);
    requestAnimationFrame(function () { apply(root, variant.id); });
  }, true);
})();
